import * as React from 'react';
import Svg, { ClipPath, Defs, ForeignObject, G, Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const TooltipArrow = (props: SvgProps) => (
    <Svg width={16} height={8} viewBox="0 0 16 8" fill="none" {...props}>
        <ForeignObject x={-16} y={-16} width={48} height={40} />
        <Path
            data-figma-bg-blur-radius={16}
            d="M16 0H0L6.43826 7.31751C7.23891 8.2275 8.76109 8.2275 9.56174 7.31751L16 0Z"
            fill={props.color ?? ds.colorValue.background.brand.strong}
        />
        <Defs>
            <ClipPath id="bgblur_0_75289_23355_clip_path">
                <G translate="16 16">
                    <Path d="M16 0H0L6.43826 7.31751C7.23891 8.2275 8.76109 8.2275 9.56174 7.31751L16 0Z" />
                </G>
            </ClipPath>
        </Defs>
    </Svg>
);
